"use client";

import { ReactElement } from "react";
import { ModalContext, useModal } from "../hooks/useModal";
import Dialog from "./Dialog";

/**
 * A second modal layer above the app's one, for steps taken from inside a
 * dialog (the submit form) that must leave it as it is. Its content gets the
 * layer's own ModalContext, so a paywall or the connect dialog opening or
 * closing "the modal" acts on this layer only. Render `layer` once.
 */
export function useStackedModal(): { modal: ReturnType<typeof useModal>; layer: ReactElement } {
  const modal = useModal();
  const layer = (
    <ModalContext.Provider value={modal}>
      <Dialog
        ref={modal.ref}
        isOpen={modal.isOpen}
        onClose={modal.dismiss}
        className={modal.className}
        disabledPadding={modal.disabledPadding}
        // Above the app modal's z-[9999], as ManageAccountsDialog stacks.
        overlayClassName="!z-[10000]"
      >
        {modal.children}
      </Dialog>
    </ModalContext.Provider>
  );
  return { modal, layer };
}
